import React from "react";

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="w-full flex items-center justify-between px-3 sm:px-4 md:px-6 py-2 md:py-3 z-20 relative bg-gradient-to-b from-[#0f172a]/80 to-transparent border-b border-gray-700/20">
      {/* Left: Logo & Company Name */}
      <div className="flex items-center space-x-2 sm:space-x-3 text-gray-300 hover:text-white cursor-pointer transition-all duration-300 min-w-0">
        <img
          src="https://khothi-cms.buso.asia/images/logo.png"
          alt="Khơ Thị Logo"
          className="h-6 sm:h-8 w-auto object-contain drop-shadow-md filter brightness-110 flex-shrink-0"
        />
        <span className="font-bold tracking-widest text-xs sm:text-sm uppercase text-gray-400 hidden sm:inline truncate">
          VIỆN THẨM MỸ KHƠ THỊ
        </span>
      </div>

      {/* Right: User Actions */}
      <div className="flex items-center space-x-2 sm:space-x-4">
        {/* User Profile Dropdown */}
        <div className="flex items-center space-x-1.5 sm:space-x-2 bg-gray-800 bg-opacity-50 rounded-full py-1 px-2 sm:px-3 cursor-pointer hover:bg-opacity-70 transition hidden xs:flex">
          <img
            src="https://ui-avatars.com/api/?name=Ngoc&background=fca5a5&color=fff&rounded=true&size=24"
            alt="User"
            className="w-5 sm:w-6 h-5 sm:h-6 rounded-full flex-shrink-0"
          />
          <span className="text-gray-200 font-medium text-xs hidden sm:inline">Ngọc</span>
          <i className="fa-solid fa-chevron-down text-gray-400 text-[8px] sm:text-[10px] hidden sm:inline" />
        </div>

        {/* Icon Buttons */}
        <div className="flex items-center space-x-2 sm:space-x-3 text-gray-400">
          <button
            type="button"
            className="hover:text-white transition p-1.5 sm:p-2 rounded-full hover:bg-gray-700/30"
            aria-label="Notifications"
            title="Notifications"
          >
            <i className="fa-solid fa-bell text-sm sm:text-base" />
          </button>
          <button
            type="button"
            className="hover:text-white transition p-1.5 sm:p-2 rounded-full hover:bg-gray-700/30 hidden sm:block"
            aria-label="Inbox"
            title="Inbox"
          >
            <i className="fa-solid fa-box text-sm sm:text-base" />
          </button>
          <button
            type="button"
            className="hover:text-white transition p-1.5 sm:p-2 rounded-full hover:bg-gray-700/30 md:hidden"
            aria-label="Sidebar menu"
            title="Menu"
            onClick={onMenuClick}
          >
            <i className="fa-solid fa-bars text-sm sm:text-base" />
          </button>
          <button
            type="button"
            className="hover:text-white transition p-1.5 sm:p-2 rounded-full hover:bg-gray-700/30 hidden md:block"
            aria-label="Menu"
            title="Menu"
          >
            <i className="fa-solid fa-bars text-base" />
          </button>
        </div>
      </div>
    </header>
  );
}